<template>
  <v-card-actions class="card-padding">
    <v-row>
      <v-col cols="3" lg="3" class="d-flex align-center" v-if="itemsSelectDisabled">
        <div style="position: relative; top: 13px">
          <v-select
            :items="itemsSelect"
            outlined
            small
            dense
            :value="itemsPerPage"
            @change="itemsPerPageChange"
          ></v-select>
        </div>
        <span style="white-space: nowrap; margin-left: 10px">
          共 {{ total }} 条
        </span>
      </v-col>
      <v-col cols="6" class="ml-auto d-flex justify-end">
        <v-pagination
          prev-icon="fa fa-angle-left"
          next-icon="fa fa-angle-right"
          class="pagination"
          color="#4caf50"
          :value="page"
          :length="pageCount"
          @input="pageInput"
          circle
        ></v-pagination>
      </v-col>
    </v-row>
  </v-card-actions>
</template>
<script>
export default {
  name: "Pagination",
  props: {
    page: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 1,
    },
    itemsPerPage: {
      type: Number,
      default: 5,
    },
    itemsSelect: {
      type: Array,
      default: ()=>{
        return  [5, 10, 25, 50]
      }
    },
    itemsSelectDisabled: {
      type: Boolean,
      default:false
    }
  },
  computed: {
    pageCount() {
      return this.total ? Math.ceil(this.total / this.itemsPerPage) : 0;
    },
  },
  data: () => {
    return {};
  },

  methods: {
    itemsPerPageChange(value) {
      this.$emit("update:page", 1);
      this.$emit("update:itemsPerPage", value);
      this.$emit("refresh");
    },
    pageInput(page) {
      this.$emit("update:page", page);
      this.$emit("refresh");
    },
  },
};
</script>
